import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconS24Picture48, IconS24Plus24 } from '@is24/cosma-ui-icons'
import { Button } from 'is24-corecss'

import styles from '../common/MultimediaButtonCommon.module.css'
import { createAndTriggerPluploadFileInput } from '../../../utils/fileUploadUtils'

interface InitialUploadClickableAreaProps {
  dropzoneId: string
  pluploadRef?: React.Ref<HTMLDivElement>
}
export const InitialUploadClickableArea: React.FC<InitialUploadClickableAreaProps> = ({ dropzoneId, pluploadRef }) => {
  const { t } = useTranslation()

  return (
    <>
      <div ref={pluploadRef} style={{ display: 'none' }} />
      <div
        id={dropzoneId}
        className={`${styles.clickAbleAreaWrapper} grid grid-flex grid-justify-center gap-l`}
        onClick={() => createAndTriggerPluploadFileInput()}
        role='button'
        tabIndex={0}
      >
        <IconS24Picture48 className={'grid-item one-whole font-default-color'} />
        <span className={`grid-item one-whole align-center ${styles.description} font-body-medium-regular`}>
          {t('wizard.screen.multimediaNewModalContent.mobile.clickableAreaTitle')}
        </span>
        <Button appearance='link' className={`${styles.cta} grid-item one-whole align-center font-body-medium-bold`}>
          <IconS24Plus24 width={16} height={16} className='button-icon-margin-right font-default-color' inline />
          {t('wizard.screen.multimediaNewModalContent.mobile.button')}
        </Button>
      </div>
    </>
  )
}
